import { render, staticRenderFns } from "./DonateItem.vue?vue&type=template&id=734f2041&scoped=true"
import script from "./DonateItem.vue?vue&type=script&lang=js"
export * from "./DonateItem.vue?vue&type=script&lang=js"
import style0 from "./DonateItem.vue?vue&type=style&index=0&id=734f2041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734f2041",
  null
  
)

export default component.exports